import { PlotData } from "plotly.js";
import { Legend } from "../COREChartLegend";

/**
 * Generic type for traces that can be used with legend generation.
 * Extends any trace type with required legend fields.
 */
export type TraceForLegend<T = Record<string, any>> = T & {
  name?: string;
  marker?: PlotData["marker"];
  line?: { color?: string };
  "line.color"?: string;
  "line.dash"?: string;
  fillcolor?: string;
};

const getTraceColor = <T>(item: TraceForLegend<T>): string => {
  if ("marker" in item && item.marker && "color" in item.marker) {
    return item.marker.color as string;
  }

  if ("line.color" in item && item["line.color"]) {
    return item["line.color"] as string;
  }

  if ("line" in item && item.line && "color" in item.line) {
    return item.line.color as string;
  }

  if ("fillcolor" in item && item.fillcolor) {
    return item.fillcolor as string;
  }

  return "#000000";
};

export const generateChartLegends = <T>(
  traces: TraceForLegend<T>[]
): Legend[] => {
  return traces.map((item) => {
    const legend: Legend = {
      label: item.name || "",
      color: getTraceColor(item),
      checked: true,
      key: item.name?.replaceAll(" ", "-") || "",
    };

    if (item["line.dash"]) {
      if (
        ["dash", "longdash", "dashdot", "longdashdot"].includes(
          item["line.dash"]
        )
      ) {
        legend.tagStyle = "dashed";
      } else if (item["line.dash"] === "solid") {
        legend.tagStyle = "outline";
      }
    }

    return legend;
  });
};
